var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomSelectComponent',{attrs:{"is-required":true,"value":_vm.value,"options":_vm.options,"placeholder":"Level"},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }